import { useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import CategoryApi from '../../../lib/api/category/CategoryApi';
import { CATEGORY } from '../../../constants/queryKeys';

const useDeleteSubCategory = () => {
  const { id } = useParams();

  const queryClient = useQueryClient();

  const deleteSubCategory = useMutation({
    mutationFn: ({ subId }) => CategoryApi.deleteSubCategory(id, subId),
    onSuccess: () => {
      queryClient.invalidateQueries([...CATEGORY.SUB_CATEGORY_LIST, id]);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteSubCategory };
};

export default useDeleteSubCategory;
